module.exports = __webpack_public_path__ + "static/img/9shaixuan2.6d77577.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/9shaixuan2.png
// module id = Drhy
// module chunks = 1